import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useScope } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import TicketGrid from './components/TicketGrid';

export function TicketGridView(props) {
  const { t } = useTranslation();
  const { customer, siteGroup } = useScope();
  return (
    <AppNav flex notFullHeight page="plant_tickets" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={t('support.ticketList', 'Tickets')} />
        <TicketGrid customerId={customer?.id} siteGroupId={siteGroup?.id} />
      </Box>
    </AppNav>
  );
}

export default TicketGridView;
